import { render, staticRenderFns } from "./InsightCustomerFeedbackPopup.vue?vue&type=template&id=a4b74490&scoped=true"
import script from "./InsightCustomerFeedbackPopup.vue?vue&type=script&lang=js"
export * from "./InsightCustomerFeedbackPopup.vue?vue&type=script&lang=js"
import style0 from "./InsightCustomerFeedbackPopup.vue?vue&type=style&index=0&id=a4b74490&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b74490",
  null
  
)

export default component.exports